module.exports = "/fonts/fa-regular-400.ttf?54f142e03adc6da499c2af4f54ab76fd";